import Phaser from 'phaser';
import { Damageable } from '../systems/CombatSystem';

export const BARREL_SPLASH_RADIUS = 80; // px
export const BARREL_SPLASH_DAMAGE = 40;
export class ExplosiveBarrel extends Phaser.GameObjects.Container implements Damageable {
  private detonated: boolean = false;
  readonly onDetonate: (x: number, y: number) => void;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    onDetonate: (x: number, y: number) => void
  ) {
    super(scene, x, y);

    // Barrel body
    const body = scene.add.rectangle(0, 0, 16, 20, 0x6b3a10).setStrokeStyle(2, 0x3d1e00);
    // Barrel bands
    const band1 = scene.add.rectangle(0, -5, 18, 3, 0xcc4400);
    const band2 = scene.add.rectangle(0, 5, 18, 3, 0xcc4400);

    this.add([body, band1, band2]);
    scene.add.existing(this);
    this.setDepth(8);
    this.onDetonate = onDetonate;
  }

  isDead(): boolean {
    return this.detonated;
  }

  takeDamage(_amount: number): void {
    if (this.detonated) return;
    this.detonated = true;
    const ex = this.x;
    const ey = this.y;
    this.destroy();
    this.onDetonate(ex, ey);
  }
}
